export default class NoticeService {
  constructor(logger, router, store, eventBus) {
    this.logger = logger;
    this.router = router;
    this.store = store;
    this.eventBus = eventBus;

    // this.intro = introJs();
  }

  startGuide(notice) {
    if (notice.guide_redirect) {
      this.router.push(notice.guide_redirect.replace(':member_id', this.store.state.user.memberId), () => {
        this.eventBus.once('pageMounted', (vm) => {
          vm.$nextTick(() => {
            this.showGuide(notice);
          });
        });
      });
    } else {
      this.showGuide(notice);
    }
  }

  showGuide(notice) {
    const guide = JSON.parse(notice.guide);
    guide.steps.forEach((step, i) => {
      guide.steps[i].element = document.evaluate(
        step.element, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null,
      ).singleNodeValue;
    });

    this.intro.setOptions(guide).start();
  }
}
